export default class HeaderController {
    static openSearch() {
        const bar = document.getElementById('header_search_bar');

        if (!bar || !bar.classList.contains('d-none')) return;

        bar.classList.replace('d-none', 'open');
        bar.querySelectorAll('input.SearchBar__input, input.ProductSearchBar__input').forEach((i) => i.focus());
        bar.dispatchEvent(new CustomEvent('open.search'));
            // Close all navigation panels when search opens
        document.querySelectorAll('.js-navigation-panel, .js-category-panel').forEach(panel => {
            panel.classList.add('d-none');
        });
    }
    

    static closeSearch() {
        const bar = document.getElementById('header_search_bar');

        if (!bar || !bar.classList.contains('open')) return;

        bar.classList.replace('open', 'd-none');
        bar.dispatchEvent(new CustomEvent('close.search'));
    }

    static init() {
        ['header_search', 'header_searchMobile'].forEach((btnId) => {
            const btn = document.getElementById(btnId);

            if (!btn) return;
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const bar = document.getElementById('header_search_bar');

                if (!bar) return;
                HeaderController.openSearch();
            });
        });

        const bar = document.getElementById('header_search_bar');

        if (bar) {
            bar.addEventListener('click', (e) => e.stopPropagation());
        }

        document.addEventListener('click', () => {
            HeaderController.closeSearch();
        });

        const userBtn = document.getElementById('userMenu');

        if (userBtn && window.bootstrap?.Dropdown) {
            new window.bootstrap.Dropdown(userBtn);
        }

        document.querySelector('.header__navigation__shopping_cart')?.addEventListener('click', (e) => {
            const oldURL = window.location.href;

            history.pushState(null, '', '#shopping-cart');
            window.dispatchEvent(new HashChangeEvent('hashchange', { oldURL, newURL: window.location.href }));
        });
    }
}
